const alphabeticalyCellularFirst = (a, b) => {
  if (!a.isCellular && b.isCellular) { return 1 }
  if (a.isCellular && !b.isCellular) { return -1 }

  return a.name > b.name ? 1 : -1
}

export default alphabeticalyCellularFirst
